import React, { useEffect, useState } from "react";
import "../components/VisitedPages/visitedPages.css";
import getAllData from "../services/getAllDataStart";

const VisitedPages = () => {
  const [allData, setAllData] = useState([]);
  const [source,setSource] = useState("none");
  const [amount,setAmount] = useState("10");

  useEffect(() => {
    getData(source,amount);
  }, [source,amount]);

  function getData(source,limit) {
    let formData = new FormData();

    formData.append("sourcePage", source);
    formData.append("limit", limit);

    getAllData(formData).then((response) => {
      let _respuesta = JSON.parse(response);
      if (_respuesta.response === "success") {
        setAllData(_respuesta.data);
        console.log(_respuesta.data);
      }
    });
  }
  return allData.length > 0 ? (
    <div className="container" id="visitedPages">
      <div className="col-12 home__title my-3">Historial</div>

      <div className="row my-3">
        <div className="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <h4>Selecciona una opción: </h4>
          <select className="visitedPage__select" 
            name="platform"
            id="type"
            onChange={(e) => setSource(e.target.value)}>
            <option value="none">Todo</option>
            <option value="eja">Enlace Jurídico Académico</option>
            <option value="opinio">Revista Opinio Iuris</option>
          </select>
          <h4>Selecciona la cantidad de registros: </h4>
          <select className="visitedPage__select" 
            name="amount"
            id="amount"
            onChange={(e) => setAmount(e.target.value)}>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="all">Todo</option>
          </select>
        </div>
      </div>
      <div className="col-12">

        <table className="table table-striped table-dark">
          <thead>
            <tr>
              <th scope="col">Fecha</th>
              <th scope="col">Página de visitada</th>
              <th scope="col">Página de entrada</th>
              <th scope="col">ID</th>
            </tr>
          </thead>
          {allData.map(data => (
              <thead key={data.id_visitor}>
              <tr>
                <th scope="col">{data.date_visited}</th>
                <th scope="col">{data.page_visited}</th>
                <th scope="col">{data.source_page}</th>
                <th scope="col">{data.visitor_ip}</th>
              </tr>
            </thead>
          ))}
          {/* <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">First</th>
              <th scope="col">Last</th>
              <th scope="col">Handle</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>Jacob</td>
              <td>Thornton</td>
              <td>@fat</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>Larry</td>
              <td>the Bird</td>
              <td>@twitter</td>
            </tr>
          </tbody> */}
        </table>
      </div>
    </div>
  ) : (
    <div className="d-flex justify-content-center">
      <div className="spinner-border" role="status">
        <span className="sr-only"></span>
      </div>
    </div>
  );
};

export default VisitedPages;
